import React from 'react';
import { useTranslation } from 'react-i18next';
import type { RefreshInterval } from '@/features/header/constants/labels';
import { BdsIcon } from '@/core/constants/webComponents';
import { showFilterBarButtonTooltip } from './tooltipPosition';

interface RefreshIntervalButtonProps {
  activeInterval: RefreshInterval;
  onClick: () => void;
  disabled?: boolean;
  showTooltip: (left: number, top: number, items: string[], rightAligned?: boolean) => void;
  hideTooltip: () => void;
}

export const RefreshIntervalButton: React.FC<RefreshIntervalButtonProps> = ({ activeInterval, disabled = false, onClick, showTooltip, hideTooltip }) => {
  const { t } = useTranslation();
  const showCurrentTooltip = (target: HTMLElement) => {
    showFilterBarButtonTooltip(target, t('filterBar.changeRefreshInterval'), showTooltip);
  };

  return (
    <div className={`__icon-button __tooltip-wrapper${activeInterval !== 0 ? ' __icon-button--active' : ''}`}>
      <button
        type="button"
        className="filter-bar__action-button"
        data-testid="btn-refresh-interval"
        onClick={onClick}
        disabled={disabled}
        style={{ padding: '0 4px', width: '100%', height: '100%' }}
        onMouseEnter={(e) => showCurrentTooltip(e.currentTarget)}
        onFocus={(e) => showCurrentTooltip(e.currentTarget)}
        onTouchStart={(e) => showCurrentTooltip(e.currentTarget)}
        onMouseLeave={hideTooltip}
        onBlur={hideTooltip}
        onTouchEnd={hideTooltip}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
          <BdsIcon name="restore" theme="outline" size="medium" color="surface-0" />
          {activeInterval !== 0 && (
            <span className="filter-bar__refresh-label">
              {activeInterval !== 60 && (`${activeInterval}m`)}
              {activeInterval === 60 && ('1h')}
            </span>
          )}
        </div>
      </button>
    </div>
  );
};
